import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';
import { Categorias } from 'src/app/interfaces/categorias';
import { Empresas } from 'src/app/interfaces/empresas';
import { Estadisticas } from 'src/app/interfaces/inicio';
import { InicioService } from 'src/app/services/inicio/inicio.service';
import { Router } from '@angular/router';
import { VacantesService } from 'src/app/services/vacante/vacantes.service';
import { Vacante } from 'src/app/interfaces/vacantes';
import { environment } from 'src/environments/environment';
import { JwtResponse } from 'src/app/interfaces/jwt';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalMessageComponent } from '../../common/modalmessage/modalmessage.component';
@Component({
  selector: 'app-home-login',
  templateUrl: './home-login.component.html',
  styleUrls: ['./home-login.component.scss']
})
export class HomeLoginComponent implements OnInit {

  verArchivos: string;
  usuario: JwtResponse;
  categoriasEmpleos: Categorias[];
  estadisticas: Estadisticas = {} as Estadisticas;
  empresas: Empresas[];
  vacantes: Vacante[];
  cantidadVacantes: number;
  noPagina: number;
  dato: string;

  constructor(private title: Title, private meta: Meta, private router: Router,
    private inicioService: InicioService, private vacantesService: VacantesService,
    @Inject(PLATFORM_ID) private platformId: object, private modalService: NgbModal) {
      this.usuario = JSON.parse(localStorage.getItem('currentUser'));
      this.agregarMetaData();
      this.cantidadVacantes = 6;
      this.verArchivos = environment.baseArchivos;
  }

  ngOnInit(): void {
    if(this.usuario){
      this.usuario.user.img = (this.usuario.user.img != environment.empresaDefault ? this.verArchivos + this.usuario.user.img : this.usuario.user.img);
    }
  }

  private agregarMetaData(): void {
    this.title.setTitle('TG Empleos - Empresa');
    this.meta.updateTag({name: "description", content: "Publica tus vacantes, edita tu perfil y visualiza quienes se postularon a tus vacantes"});//falta descripcion e imagen para mostrar en open graph
    this.meta.updateTag({name: "keywords", content: "empresas, inicio, dato, información, vacantes, postulación, perfil, empresa"});
    this.meta.updateTag({name: "robots", content: "noodp"});
    this.meta.updateTag({property: "og:title", content: "Tec Gurus - Empresa"});
    this.meta.updateTag({property: "og:description", content: "Publica tus vacantes, edita tu perfil y visualiza quienes se postularon a tus vacantes"});
    this.meta.updateTag({property: "og:url", content: environment.baseTG});
    this.meta.updateTag({property: "og:site_name", content: "TG Empleos"});
    this.meta.updateTag({property: "og:locale", content: "es_ES"});
    this.meta.updateTag({property: "og:type", content: "website"});
    this.meta.updateTag({property: "og:image", content: environment.baseAssets+"/img/sitio-web-de-tg.jpg"});
    this.meta.updateTag({name: "twitter:title", content: "Tec Gurus - Empresa"});
    this.meta.updateTag({name: "twitter:description", content:"Publica tus vacantes, edita tu perfil y visualiza quienes se postularon a tus vacantes"});
    this.meta.updateTag({name: "twitter:site", content: "@tecgurusnet"});
    this.meta.updateTag({name: "twitter:image", content: environment.baseAssets+"/img/sitio-web-de-tg.jpg"});
    this.meta.updateTag({name: "twitter:creator", content: "@tecgurusnet"});
    this.meta.updateTag({name: "twitter:card", content: "summary"});
  }

  abrirModalMessage(modalTitle: string, modalMessage: string) {
    const modalRef = this.modalService.open(ModalMessageComponent, { centered: true });
    modalRef.componentInstance.modalTitle = modalTitle;
    modalRef.componentInstance.modalMessage = modalMessage;
  }
}
